import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import LiveEvents from './components/LiveEvents';
import Categories from './components/Categories';
import LatestArticles from './components/LatestArticles';
import Benefits from './components/Benefits';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <LiveEvents />
        <Categories />
        <Benefits />
        <LatestArticles />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}